"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ISOTimeConverter = /** @class */ (function () {
    function ISOTimeConverter() {
    }
    /**
     * Converts duration given in days:hours:minutes:seconds in ISO format
     * @param duration Duration in days:hours:minutes:seconds format
     * @returns ISO formatted duration
     */
    ISOTimeConverter.toISO = function (duration) {
        var durationArray = duration.split(':');
        if (!this.doesMatchPattern(durationArray)) {
            throw new Error("The duration pattern should be in the given format: days:hh:mm:ss and withing given range: {0-999}:{00-23}:{00-59}:{00-59}");
        }
        var days = parseInt(durationArray[0]);
        var hours = parseInt(durationArray[1]) + (days * 24);
        var colanPosition = duration.indexOf(':');
        var durationArrayWithoutDays = duration.slice(colanPosition + 1).split(':');
        durationArrayWithoutDays[0] = hours.toString();
        return ISOTimeConverter.getISODuration(durationArrayWithoutDays[0], durationArrayWithoutDays[1], durationArrayWithoutDays[2]);
    };
    ISOTimeConverter.getISODuration = function (hours, minutes, seconds) {
        var isoDuration = "PT" + hours + "H" + minutes + "M" + seconds + "S";
        return isoDuration;
    };
    ISOTimeConverter.doesMatchPattern = function (durationArray) {
        if ((!isInteger(durationArray[0])) || (!isInteger(durationArray[1]))
            || (!isInteger(durationArray[2])) || (!isInteger(durationArray[3]))) {
            return false;
        }
        var days = parseInt(durationArray[0]);
        var hours = parseInt(durationArray[1]);
        var min = parseInt(durationArray[2]);
        var seconds = parseInt(durationArray[3]);
        if ((days >= 0) && (days < 9999) &&
            (hours >= 0) && (hours < 24) &&
            (min >= 0) && (min < 60) &&
            (seconds >= 0) && (seconds < 60)) {
            return true;
        }
        return false;
    };
    return ISOTimeConverter;
}());
exports.ISOTimeConverter = ISOTimeConverter;
function isInteger(value) {
    if (!isNaN(value) && value.toString().indexOf('.') === -1) {
        return true;
    }
}
//# sourceMappingURL=ISOTimeConverter.js.map